import React, { FC } from 'react';
import { GtmManager } from '../../utils/GtmManager';

interface Props {
  text: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
}

const BlockLink: FC<Props> = ({ text, url, title, className }) => {
  const clickLink = () => {
    if (url) {
      GtmManager.sendHeaderLinkClickGTM(url);
    }
  };
  return (
    <>
      <div className={`block-link ${className}`}>
        <a
          href={url}
          rel="noopener noreferrer"
          onClick={clickLink}
          target="_blank"
          title={title}
        >
          {text}
        </a>
      </div>
    </>
  );
};

export default BlockLink;
